import { Ltr } from "../components/Bdi.js";
import { CONTACT_EMAIL, CONTROLLER, EFFECTIVE_DATE, LEGAL } from "../content/legal.js";
import { useT } from "../i18n/LocaleProvider.js";
import { useDocumentTitle } from "../lib/useDocumentTitle.js";

/** Renders an inline email or the loud controller placeholder with the right bidi treatment. */
function Rich({ text }: { text: string }) {
  const parts = text.split(new RegExp(`(${CONTACT_EMAIL}|${CONTROLLER.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "g"));
  return (
    <>
      {parts.map((p, i) =>
        p === CONTACT_EMAIL ? (
          <a key={i} href={`mailto:${CONTACT_EMAIL}`}>
            <Ltr>{CONTACT_EMAIL}</Ltr>
          </a>
        ) : p === CONTROLLER ? (
          <strong key={i}>{p}</strong>
        ) : (
          <span key={i}>{p}</span>
        ),
      )}
    </>
  );
}

export function LegalPage({ doc }: { doc: "privacy" | "terms" }) {
  const { m, locale } = useT();
  const d = LEGAL[doc][locale];
  useDocumentTitle(doc === "privacy" ? m.meta.pages.privacy : m.meta.pages.terms);
  return (
    <div className="container container--narrow">
      <div className="page-head">
        <h1>{d.title}</h1>
        <p className="page-head__lede">
          <Rich text={d.intro} />
        </p>
        <p className="muted small">
          <Ltr>{EFFECTIVE_DATE}</Ltr>
        </p>
      </div>
      {d.reviewNotice && <p className="notice small">{d.reviewNotice}</p>}
      <article className="prose">
        {d.sections.map((s) => (
          <section key={s.heading}>
            <h2>{s.heading}</h2>
            {s.paragraphs.map((p, i) => (
              <p key={i}>
                <Rich text={p} />
              </p>
            ))}
            {s.bullets && (
              <ul>
                {s.bullets.map((b, i) => (
                  <li key={i}>
                    <Rich text={b} />
                  </li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </article>
    </div>
  );
}
